import { useForm } from "react-hook-form";
import { InputComponent } from "../../../components/InputComponent";
import { Dialog } from "primereact/dialog";
import { confirmDialog } from "primereact/confirmdialog";
import { GenericComponent } from "../../../components/GenericComponent";
import { useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { Menu } from "primereact/menu";
import { TablaDinamica } from "../../../components/TablaDinamica";
import { useLazyParams } from "../../../hooks/useLazyParams";
import { PepParticipacion } from "../../../models/ficha/PepParticipacion";
import { PepParticipacionService } from "../../../service/ficha/PepParticipacionService";

export const PepParticipacionEmpresa = ({ id, toast, permss, catalogos, soloLectura, loadLazyAfinidad }) => {

    const generic = new GenericComponent();
    const omodel = new PepParticipacion();
    const defaultValues = generic.default(omodel.model, null);
    const { control, formState: { errors }, handleSubmit, reset, setError, getValues } = useForm({ defaultValues });
    const pepSrv = new PepParticipacionService();
    const [dialogParticipacion, setDialogParticipacion] = useState(false);
    const [participacion, setParticipacion] = useState(null);
    const [load, setLoad] = useState(false);
    const menuRef = useRef(null);
    const tablaParticipacion = useLazyParams({ modelo: omodel.model });
    const { inText, inDrop, inNumber } =
        InputComponent({ registers: tablaParticipacion.data, omodel, generic, errors, control, permss, id: getValues('id'), soloLectura });

    useEffect(() => {
        if (id) loadLazy();
        // eslint-disable-next-line
    }, [tablaParticipacion.lazyParams, id]);

    const editParticipacion = () => {
        pepSrv.consulta(participacion?.id, id).then(res => {
            let _afi = res.data;
            reset(_afi);
            setDialogParticipacion(true);
        }).finally(() => {
            loadLazyAfinidad();
        });
    }

    const loadLazy = () => {
        tablaParticipacion.setLoading(true);
        const _params = { ...tablaParticipacion.lazyParams, idp: id };
        pepSrv.lista({ lazyEvent: JSON.stringify(_params) }).then(res => {
            tablaParticipacion.setTotalRecords(res.data.total);
            tablaParticipacion.setData(res.data.registros);
        }).finally(() => tablaParticipacion.setLoading(false));
    }

    const onSubmit = (data) => {
        data.idp = id;
        setLoad(true);

        const request = getValues('id') == null ? pepSrv.nuevo(data) : pepSrv.editar(data);
        request.then(res => {
            setDialogParticipacion(false);
            loadLazy();
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcError(error, toast, setError);
        }).finally(() => {
            setLoad(false);
            loadLazyAfinidad();
        });
    }

    const openNew = () => {
        setParticipacion(null);
        setDialogParticipacion(true);
        reset(defaultValues);
    }

    const confirmDelete = () => {
        confirmDialog({
            message: '¿Está seguro de eliminar la información?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => deleteParticipacion()
        });
    };

    const deleteParticipacion = () => {
        pepSrv.eliminar(participacion?.id, id).then(res => {
            loadLazy();
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcDeleteError(error, toast);
        }).finally(() => {
            loadLazyAfinidad();
        });
    }

    const onError = () => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Se detectaron errores, por favor revise el formulario para corregir.', life: 3000 });
    }

    const itemsMenu = () => {
        if (soloLectura) {
            return [{ label: 'Opciones', items: [{ label: 'Ver detalle', icon: 'pi pi-eye', command: () => editParticipacion() }] }];
        }

        const items = [];
        if (permss?.actualizar && (!participacion?.nemonico || participacion.nemonico !== 'FINALIZADO'))
            items.push({ label: 'Editar', icon: 'pi pi-pencil', command: () => editParticipacion() });
        if (permss?.eliminar && (!participacion?.nemonico || participacion?.nemonico !== 'FINALIZADO'))
            items.push({ label: 'Eliminar', icon: 'pi pi-trash', command: () => confirmDelete() });

        return [{ label: 'Opciones', items: items }];
    }

    const accionesTemplate = (rowData) => (
        <Button
            icon="pi pi-caret-down"
            type="button"
            className="p-button-rounded p-button-success mr-2"
            title="Opciones/Acciones"
            aria-controls="popup_menu_participacion"
            aria-haspopup
            onClick={(e) => { setParticipacion(rowData); menuRef.current.toggle(e); }}
        />
    );

    const ColumnaAcciones = (
        <Column header="Acciones" body={accionesTemplate} style={{ width: '4rem', textAlign: 'center' }} frozen alignFrozen="right" />
    );

    const cabeceraTabla = () => (
        <div className="flex align-items-center justify-content-start gap-3 py-1">
            {permss?.crear && id && !soloLectura && (
                <Button icon="pi pi-plus" className="p-button-success p-button-sm" type="button" onClick={openNew} />
            )}
            <span className="text-sm font-semibold text-600">
                Listado de personas jurídicas - participación
            </span>
        </div>
    );

    return (
        <>
            <Menu model={itemsMenu()} popup ref={menuRef} id="popup_menu_participacion" />
            <TablaDinamica
                modelo={omodel.model}
                estadoTabla={tablaParticipacion}
                datos={tablaParticipacion.data}
                totalRegistros={tablaParticipacion.totalRecords}
                dataKey="id"
                acciones={ColumnaAcciones}
                header={cabeceraTabla()}
            />

            <Dialog visible={dialogParticipacion} header={soloLectura ? "Ver Información" : (getValues('id') == null ? "Nueva Información" : "Editar Información")} modal className="p-fluid modal-ssize"
                onHide={() => setDialogParticipacion(false)} style={{ width: '450px' }}>
                <form onSubmit={(e) => { e.stopPropagation(); handleSubmit(onSubmit, onError)(e); }}>
                    <div className="col-12 mb-3">
                        <div className="flex align-items-center">
                            <span className="text-800 font-bold text-base mr-3 flex align-items-center gap-2">
                                <i className="pi pi-building-columns text-primary"></i>
                                PARTICIPACIÓN EN EMPRESA
                            </span>
                            <div className="border-bottom-1 border-300 flex-grow-1" style={{ height: '1px' }}></div>
                        </div>
                    </div>

                    <Card className="mb-3 section-card">
                        <div className="formgrid grid">
                            {inText('razon_social', {}, 12)}
                            {inDrop('nacionalidad', catalogos?.nacionalidad, { lab: 'nombre' }, 12)}
                            {inNumber('porcentaje', 2, false, {}, 12)}
                        </div>
                    </Card>

                    {soloLectura ? (
                        <div className="flex justify-content-end mt-3">
                            <Button label="Cerrar" icon="pi pi-times" type="button" className="p-button-warning" onClick={() => setDialogParticipacion(false)} />
                        </div>
                    ) : (
                        generic.buttonsForms(setDialogParticipacion, load)
                    )}
                </form>
            </Dialog>
        </>
    )
}
